import React from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    btn: {
      marginTop: '41px',
      width: '40%',
    },
    container: {
      maxWidth: '396px',
      padding: '56px 46px',
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    message: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '22px',
      marginBottom: '0px',
    },
  };
});
export default ({ onCancel, onConfirm }) => {
  const classes = useStyles();
  return (
    <Container disableGutters className={classes.container}>
      <Grid container className="text-left-">
        <Grid item xs={12} className="text-left">
          <Typography variant="h4" className={`page-header ${classes.formTitle}`}>
            Send to Mediphany
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" className={`body-copy ${classes.message}`}>
            To send the case off to Mediphany to create a video report for the patient, please click the “confirm” button below.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={6} style={{ paddingRight: '6px' }}>
              <Button variant="outlined" style={{ width: '100%' }} fullWidth size="medium" color="primary" onClick={onCancel} className={classes.btn}>
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6} style={{ paddingLeft: '6px' }}>
              <Button variant="contained" style={{ width: '100%' }} fullWidth size="medium" color="primary" onClick={onConfirm} className={classes.btn}>
                Confirm
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
